// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// NOTE: `fileReplacements` is declared only on the production configuration, so a
// development build ships THIS file verbatim — including to the deployed dev site.
// The active block below must always be the deployed-dev one.

// DEPLOYED DEV configuration (evideb2cdev B2C tenant). This is the block a
// development build ships.
export const environment = {
  authorityDomain: 'evideb2cdev.b2clogin.com',
  production: false,
  projectName: 'Evide Impact Tracker – DEV',
  baseUrl: 'https://adminapi-evide-dev-ukwest-01.azurewebsites.net/',
  imgUrl: 'https://adminapi-evide-dev-ukwest-01.azurewebsites.net',
  redirectUri: 'https://witty-water-0ee69a303.6.azurestaticapps.net',
  postLogoutRedirectUri: 'https://witty-water-0ee69a303.6.azurestaticapps.net',
  clientId: 'bd54c3b2-9503-4f28-9358-cef33dec1fa1',
  // Scope exposed on this app registration (B2C > App registrations > Expose an API),
  // and granted to the app itself under API permissions with admin consent. When set,
  // API calls carry a silently-renewable access token instead of the ID token.
  // Absent or '' falls back to the ID-token behaviour — note that a misconfigured
  // scope ALSO falls back silently, so verify with jwt.ms (`scp` present) rather
  // than by the app appearing to work.
  apiScope: 'https://evideb2cdev.onmicrosoft.com/bd54c3b2-9503-4f28-9358-cef33dec1fa1/access'
};

// LOCAL TESTING ONLY — points at the local backend on :5000. Uncomment this block
// (and comment the deployed-dev block above) to run against localhost. Never commit
// with this active: the dev site would be pointed at a developer's machine.
// export const environment = {
//   authorityDomain: 'evideb2cdev.b2clogin.com',
//   production: false,
//   projectName: 'Evide Impact Tracker – DEV',
//   baseUrl: 'http://localhost:5000/',
//   imgUrl: 'http://localhost:5000',
//   redirectUri: 'http://localhost:4200/',
//   postLogoutRedirectUri: 'http://localhost:4200/',
//   clientId: 'bd54c3b2-9503-4f28-9358-cef33dec1fa1',
//   apiScope: 'https://evideb2cdev.onmicrosoft.com/bd54c3b2-9503-4f28-9358-cef33dec1fa1/access'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
